import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getOfficeFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at offices and corporate campuses?`,
    answer: `Food ${vehicleType}s visit your workplace on a scheduled basis and sell food directly to employees or tenants. ${siteTitle} curates and manages a rotating lineup of food ${vehicleType}s, handling scheduling, vendor coordination, and communication. Trucks arrive fully self-contained, serve lunch on-site, and leave with no cleanup required from your team.`
  },
  {
    question: `Does it cost businesses anything to host food ${vehicleType}s on-site?`,
    answer: `Food ${vehicleType} programs are customized based on your location, schedule, and goals. Some workplaces host food ${vehicleType}s with minimal direct costs, while others choose structured programs that include coordination, scheduling, or employee meal support. We'll always outline pricing clearly upfront so you can choose the setup that works best for your team.`
  },
  {
    question: `How often can food ${vehicleType}s come to my workplace?`,
    answer: `Food ${vehicleType}s can be scheduled daily, weekly, or on a rotating basis depending on your location and employee demand. Many offices choose recurring lunch schedules to give employees consistent on-site dining options while maintaining variety through different cuisines.`
  },
  {
    question: `What space or setup is required to host a food ${vehicleType} at work?`,
    answer: `Most workplaces only need a flat parking area approximately 30 feet by 8 feet for food ${vehicleType} setup. Food ${vehicleType}s are fully self-sufficient and do not require power, water, or kitchen access. If there are questions about site access, traffic flow, or timing, our team helps coordinate details in advance.`
  },
  {
    question: 'Can employees pre-order or pay for food online?',
    answer: `Yes. Employees can order directly at the ${vehicleType} or place orders online to skip the line. Weekly menu emails and a dedicated location page make it easy for employees to see which food ${vehicleType}s are scheduled and plan their lunch ahead of time.`
  },
  {
    question: `Why are food ${vehicleType}s a good workplace perk for employees?`,
    answer: `Food ${vehicleType}s create a convenient, social dining experience that boosts morale, encourages employees to step away from their desks, and strengthens workplace culture. Companies often use food ${vehicleType} programs to support employee retention, recruitment, and overall satisfaction—without the cost and complexity of operating a full cafeteria.`
  }
];

function OfficeFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getOfficeFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default OfficeFaq;
